

import "flatpickr/dist/flatpickr.min.js";
import flatpickr from "flatpickr";

window.flatpickr = flatpickr;
